import { createSlice } from "@reduxjs/toolkit";
import { defaultAddReducer, defaultSetReducer, defaultUpdateReducer, defaultRemoveReducer } from "./defaultReducer";

const initialState = {
  list: [],
};

const slice = createSlice({
  name: "users",
  initialState,
  reducers: {
    // Give case reducers meaningful past-tense "event"-style names
    setUsersReducer: defaultSetReducer,
    updateUserReducer: defaultUpdateReducer,
    addUserReducer: defaultAddReducer,
    removeUserReducer: defaultRemoveReducer,
  },
});

// `createSlice` automatically generated action creators with these names.
// export them as named exports from this "slice" file
export const { setUsersReducer, updateUserReducer, addUserReducer, removeUserReducer } = slice.actions;

// Export the slice reducer as the default export
export default slice.reducer;
